import { render, staticRenderFns } from "./VehiculosHolder.vue?vue&type=template&id=04fb4216"
import script from "./VehiculosHolder.vue?vue&type=script&lang=js"
export * from "./VehiculosHolder.vue?vue&type=script&lang=js"
import style0 from "./VehiculosHolder.vue?vue&type=style&index=0&id=04fb4216&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports